"use strict";

import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { ClickToDialViewMode } from "@/Common/Components/CallCenter/ClickToDial.types";
import { ClickToDialViewPhoneNumber } from "@/Common/Components/CallCenter/ClickToDialViewPhoneNumber";
import { Popup } from "@/Common/Components/Modals/Popup";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { CallCenterUserConnectionState } from "@/Common/Models/CallCenter/CallCenterUserConnectionState";

interface IClickToDialPopUpProps {
    phone: PhoneNumber
    onCloseDelegate: () => void
    onEditClickDelegate: (contactPointId: string) => void
}

function ClickToDialPopUp(props: Readonly<IClickToDialPopUpProps>): JSX.Element {
    // assume the caller does the CallCenter feature flag check. No need to check here
    const { getText } = useTranslation();

    const { phone, onCloseDelegate, onEditClickDelegate } = props;

    function getProviderName(isActive: boolean, providerType: string): string {
        if (!isActive
            || IsNullOrWhiteSpace(providerType)) {
            return getText("CallCenter_OperatingSystemProviderName");
        }
        return providerType;
    }

    const id: string = "clickToDialPopup";
    const isActive: boolean = sessionStore.CallCenter_UserConnectionState === CallCenterUserConnectionState.Connected;
    const providerType: string = sessionStore.CallCenter_Credentials?.Provider ?? null;
    const providerName = getProviderName(isActive, providerType);
    const title: string = getText("CallCenter_ClickToDialPopUp_Title");
    const dialByVoip: string = getText("CallCenter_ClickToDialPopUp_DialByVoip", { providerType: providerName });
    const editContacts: string = getText("CallCenter_ClickToDialPopUp_EditContacts");

    return (
        <Popup
            Id={id}
            title={title}
            titleLowerCase={true}
            altView={false}
            manageOverlay
            onCloseDelegate={onCloseDelegate}
        >
            <div className="p-body">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="row">
                            <div className="col-sm-12">
                                <strong>{dialByVoip}: </strong>
                                <ClickToDialViewPhoneNumber
                                    viewMode={ClickToDialViewMode.Hyperlink}
                                    phoneNumber={phone}
                                    onSuccessfulDial={onCloseDelegate}
                                    forActivePatient
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <strong>
                                    <a onClick={() => onEditClickDelegate(phone.ContactPoint_id)}>{editContacts}</a>
                                </strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    );
}

export { ClickToDialPopUp };
